import Vue from 'vue/dist/vue.js';

import 'bootstrap/dist/css/bootstrap.min.css'
Vue.config.productionTip = false

// component start
Vue.component('login', require('@/components/Home/Login.vue').default);
Vue.component('pwdsetting', require('@/components/Home/pwdsetting.vue').default);
Vue.component('pwdchanger', require('@/components/Home/pwdchanger.vue').default);
Vue.component('pwdunlock', require('@/components/Home/pwdunlock.vue').default);
Vue.component('wrapper', require('@/components/Home/wrapper.vue').default);
// CMSH-996 TOTP 도입
Vue.component('totpenroll', require('@/components/Home/totpenroll.vue').default);
Vue.component('totpverify', require('@/components/Home/totpverify.vue').default);

// component end

window.Vue = Vue;